import { memo } from "react";
import TextField, { type TextFieldProps } from "@mui/material/TextField";
import { getFormInputProps } from "util/forms";
import { when } from "util/support";
import { FormField, type SetupProps } from "./types";

const Description = ({
    values,
    handleChange,
    handleBlur,
    ...restProps
}: SetupProps) => {
    const getTextFieldProps = (): TextFieldProps => when(
        values[FormField.ValueType].startsWith('csv'),
        {
            sx: {
                gridColumn: 'span 2'
            },
            rows: 3,
            multiline: true
        },
        {}
    );

    return (
        <TextField
            {...getTextFieldProps()}
            {...getFormInputProps(FormField.Obs, restProps)}
            fullWidth
            size='small'
            name={FormField.Obs}
            value={values[FormField.Obs] ?? ''}
            label='Description'
            onChange={handleChange}
            onBlur={handleBlur}
        />
    );
};

export default memo(Description);
